
import Component from '../../../assets/scripts/modules/component'

export default class ArticleHeaderComponent extends Component {
  init () {
    this.observedIntersectionElements = this.element.querySelectorAll('.article-header__title')

    if (this.element.classList.contains('article-header-searchpage')) {
      this.initSearchInput()
    }
  }

  initSearchInput () {
    const inputEl = this.element.querySelector('input[name="q"]')
    if (!inputEl) return
    const wrapperEl = inputEl.parentNode

    wrapperEl.addEventListener('focusin', e => {
      wrapperEl.classList.remove('focusOut')
      wrapperEl.classList.add('hasFocus')
    })
    wrapperEl.addEventListener('focusout', e => {
      wrapperEl.classList.remove('hasFocus')
      wrapperEl.classList.add('focusOut')
    })

    // always use value from query string (instead of having the possibility user-entered (but not searched for) stuff from history is shown)
    inputEl.value = (new URLSearchParams(document.location.search)).get('q')
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.article-header').forEach(element => {
  element.instance = element.instance || new ArticleHeaderComponent(element)
}))
